import { pagePaths } from '../config';

export const getSurveyDetailsLink = (surveyId: string) =>
  pagePaths['Survey'].replace(':id', surveyId);
